<template>
    <FciDialog :title="this.$f.tc('stepEditor')" v-model="show">
        <v-form ref="form" v-model="formValid" class="StepEditor" @submit="submit">
            <div v-if="cloneStep" class="mb-5">
                <b>{{ $f.tc('cloneStep') }}:</b> {{ cloneStep.name }} ({{ cloneStep.cards.length }} {{$t('card')}})
            </div>
            <v-autocomplete
                outlined
                dense
                :label="this.$f.tc('scenario')"
                :items="scenarioList"
                item-text="name"
                item-value="code"
                v-model="scenarioCode"
                :rules="formRules.required"
                class="mt-2"
            ></v-autocomplete>
            <v-text-field
                outlined
                dense
                :label="this.$f.tc('name')"
                v-model="stepName"
                :rules="formRules.required"
                autofocus
                maxlength="45"
                counter="45"
            ></v-text-field>
            <v-layout>
                <v-flex></v-flex>
                <v-btn color="primary" type="submit">{{ $t('save') }}</v-btn>
            </v-layout>
        </v-form>
    </FciDialog>
</template>

<script>
import FciDialog from '@/components/FciDialog'
import DialogEditorMixin from '@/modules/fptai/mixins/DialogEditorMixin'
import { mapState } from 'vuex'

export default {
    name: 'StepEditor',
    components: { FciDialog },
    mixins: [DialogEditorMixin],
    data () {
        return {
            cloneStep: null,
            scenarioCode: '',
            stepName: ''
        }
    },
    computed: {
        ...mapState({
            scenarioList: state => state.scenario.scenarioList.filter(
                scenario => scenario.code !== state.scenario.defaultScenarioCode
            )
        })
    },
    methods: {
        onOpen () {
            this.clearForm()
            setTimeout(() => {
                this.scenarioCode = this.item ? this.item.scenario.code : ''
                this.cloneStep = this.item && this.item.cloneStep ? this.item.cloneStep : null
                if (this.cloneStep) {
                    this.stepName = this.cloneStep.name
                }
            })
        },
        submitValidForm () {
            this.close()
            let model = {
                name: this.stepName,
                scenario_code: this.scenarioCode
            }
            if (this.cloneStep) {
                model.data = JSON.stringify(this.cloneStep.cards.map(card => ({
                    type: card.card_type_id,
                    name: card.name,
                    config: JSON.stringify(card.config),
                    position: card.position,
                    active: card.activate
                })))
            }
            this.promise.resolve(model)
        }
    }
}
</script>

<style scoped lang="scss">
.StepEditor {
    padding: 10px;
}
</style>
